module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copy-1"
  }, [_vm._v("First published in Great Britain in 2022 by")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Pen & Sword Military")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("An imprint of")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Pen & Sword Books Ltd")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Yorkshire – Philadelphia")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2"
  }, [_vm._v("Copyright © Bob Paterson 2022")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2"
  }, [_vm._v("ISBN 978 1 52676 446 1")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("eISBN 978 1 52676 447 8")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2"
  }, [_vm._v("The right of Bob Paterson to be identified as Author of this work")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("has been asserted by him in accordance with the Copyright,")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Designs and Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2"
  }, [_vm._v("A CIP catalogue record for this book is")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced or")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("transmitted in any form or by any means, electronic or mechanical")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("including photocopying, recording or by any information storage")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("and retrieval system, without permission from the Publisher")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("in writing.")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2"
  }, [_vm._v("Pen & Sword Books Limited incorporates the imprints of Atlas,")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Archaeology, Aviation, Discovery, Family History, Fiction, History,")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Maritime, Military, Military Classics, Politics, Select, Transport,")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("True Crime, Air World, Frontline Publishing, Leo Cooper,")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Remember When, Seaforth Publishing, The Praetorian Press,")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Wharncliffe Local History, Wharncliffe Transport, Wharncliffe")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("True Crime and White Owl.")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2"
  }, [_vm._v("For a complete list of Pen & Sword titles please contact")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2"
  }, [_vm._v("PEN & SWORD BOOKS LIMITED")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("47 Church Street, Barnsley, South Yorkshire, S70 2AS, England")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("E-mail: "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "mailto:enquiries@pen-and-sword.co.uk"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("enquiries@pen-and-sword.co.uk")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Website: "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.pen-and-sword.co.uk",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.pen-and-sword.co.uk")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy-2"
  }, [_vm._v("Or")]), _vm._v(" "), _c('p', {
    staticClass: "copy-2"
  }, [_vm._v("PEN AND SWORD BOOKS")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("1950 Lawrence Rd, Havertown, PA 19083, USA")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("E-mail: "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "mailto:Uspen-and-sword@casematepublishers.com"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Uspen-and-sword@casematepublishers.com")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Website: "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.penandswordbooks.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.penandswordbooks.com")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06ee1bb6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Copyright.vue
// module id = 66
// module chunks = 0